import { Component } from '@angular/core';
import { environment } from '@env/environment';

import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'au-intercom-mockup',
	templateUrl: './au-intercom-mockup.component.html',
	styleUrls: ['./au-intercom-mockup.component.scss'],
	standalone: true,
	imports: [MatTooltipModule],
})
export class AuIntercomMockupComponent {
	showMockup = !environment.production;
}
